function getDateOfBirth(age: number): string {
  const timezoneOffset = '+08:00';

  const currentDate = new Date();

  const birthYear = currentDate.getFullYear() - age;

  const birthDate = new Date(currentDate);
  birthDate.setFullYear(birthYear);

  const year = birthDate.getFullYear();
  const month = String(birthDate.getMonth() + 1).padStart(2, '0');
  const day = String(birthDate.getDate()).padStart(2, '0');
  const hours = '00';
  const minutes = '00';
  const seconds = '00';

  const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${timezoneOffset}`;

  return formattedDate;
}

export { getDateOfBirth };
